export const POST_NORMALIZATION_SUCCESS =
  'NORMALIZATION::POST_NORMALIZATION_SUCCESS';

export const POST_NORMALIZATION_ERROR =
  'NORMALIZATION::POST_NORMALIZATION_ERROR';

export const RESET = 'NORMALIZATION::RESET';
